module.exports = __webpack_public_path__ + "notes_empty.11bf4e4f72939f640b3feac5d1e02a5d.svg";